import { useEffect } from "react";
import { useSocket } from "components/App/SocketContext";
import { EventType, NewSocketEvent, SocketEvent } from "components/App/SocketEvents";
import { useCurrentBusinessId } from "reducers/userReducers";

export default function useSocketEvent(name: string, callback: (payload: any) => void): void {
	const socket = useSocket();
	const businessId = useCurrentBusinessId()
	
	useEffect(() => {
		function handler(event: SocketEvent|NewSocketEvent) {
			let eventType, payload;
			if(socket.url === "wss://ws.api.vatominc.com/"){
				const message = JSON.parse((event as NewSocketEvent).data)
				eventType = message.eventType
				payload = message.eventData
			}
			else{
				eventType = (event as SocketEvent).eventType
				payload = (event as SocketEvent).payload
			}
			if(eventType === EventType.Connected){
				const subscribeRequest = {
					type: "request",
					requestType: "subscribe",
					// requestData: { topic: `/debug` },
					requestData: { topic: `/b/${businessId}` },
				  };
				  socket.send(JSON.stringify(subscribeRequest));
			}
			if (eventType === name) {
				callback(payload);
			}
		}
		
		if (socket === undefined) {
			return;
		}
		if(socket.url === "wss://ws.api.vatominc.com/"){
			socket.addEventListener("message", handler);
		}
		else{
			socket.addEventListener("event", handler);
		}
		return () => socket.removeEventListener("event", handler);
	}, [name, callback, socket]);
}
